import { createSlice } from "@reduxjs/toolkit";

const initialStats = {
  total: 0,
  processing: 0,
  queued: 0,
  completed: 0,
  failed: 0,
};

const queueSlice = createSlice({
  name: "queue",
  initialState: {
    stats: initialStats,
  },
  reducers: {
    saveQueueStats: (state, action) => {
      state.stats = {
        ...initialStats,
        ...(action.payload || {}),
      };
    },
    incrementQueueStatus: (state, action) => {
      const status = String(action.payload || "").toLowerCase();
      state.stats.total += 1;

      if (Object.prototype.hasOwnProperty.call(state.stats, status)) {
        state.stats[status] += 1;
      }
    },
    moveQueueStatus: (state, action) => {
      const from = String(action.payload?.from || "").toLowerCase();
      const to = String(action.payload?.to || "").toLowerCase();

      if (Object.prototype.hasOwnProperty.call(state.stats, from)) {
        state.stats[from] = Math.max(0, state.stats[from] - 1);
      }

      if (Object.prototype.hasOwnProperty.call(state.stats, to)) {
        state.stats[to] += 1;
      }
    },
    resetQueueStats: (state) => {
      state.stats = initialStats;
    },
  },
});

export const { saveQueueStats, incrementQueueStatus, moveQueueStatus, resetQueueStats } = queueSlice.actions;

export default queueSlice.reducer;
